import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/settler-exchange-logo B light bg stacked.png")